<template>
    <div>
        <validation-observer ref="forms" v-slot="{handleSubmit}">
            <form class="form-group text-black" @submit.prevent="handleSubmit(submitSindicato)">
                <div class="grid-1 form-1">
                    <validation-provider
                        name="Cnpj"
                        vid="cnpj"
                        rules="required"
                        v-slot="{errors}"
                        tag="div"
                        class="input-std"
                    >
                        <label>Cnpj</label>
                        <input
                            type="text"
                            placeholder="CNPJ do Sindicato"
                            v-model="form.cnpj"
                            v-mask="'##.###.###/####-##'"
                        />
                        <p class="errors">{{errors[0]}}</p>
                    </validation-provider>

                    <validation-provider
                        name="Nome"
                        vid="nome"
                        rules="required"
                        v-slot="{errors}"
                        tag="div"
                        class="input-std sm:col-span-2"
                    >
                        <label>Nome Completo do Sindicato</label>
                        <input
                            type="text"
                            placeholder="Nome Completo do Sindicato"
                            v-model="form.nome_completo"
                        />
                        <p class="errors">{{errors[0]}}</p>
                    </validation-provider>

                    <validation-provider
                        name="Nome Fantasia"
                        vid="nome_fantasia"
                        rules="required"
                        v-slot="{errors}"
                        tag="div"
                        class="input-std"
                    >
                        <label>Nome Fantasia do Sindicato</label>
                        <input
                            type="text"
                            placeholder="Nome como o sindicato é conhecido"
                            v-model="form.nome_fantasia"
                        />
                        <p class="errors">{{errors[0]}}</p>
                    </validation-provider>
                </div>

                <div class="grid-1 form-2">
                    <validation-provider
                        name="Telefone Sindicato"
                        vid="telefone_sindicato"
                        rules="required"
                        v-slot="{errors}"
                        tag="div"
                        class="input-std"
                    >
                        <label>Telefone Fixo</label>
                        <input
                            type="text"
                            placeholder="Telefone do Sindicato"
                            v-model="form.telefone"
                            v-mask="'(##) ####-####'"
                        />
                        <p class="errors">{{errors[0]}}</p>
                    </validation-provider>

                    <validation-provider
                        name="Celular"
                        vid="celular"
                        rules="required"
                        v-slot="{errors}"
                        tag="div"
                        class="input-std"
                    >
                        <label>Celular</label>
                        <input
                            type="text"
                            placeholder="Celular do Sindicato"
                            v-model="form.celular"
                            v-mask="'(##) #####-####'"
                        />
                        <p class="errors">{{errors[0]}}</p>
                    </validation-provider>

                    <validation-provider
                        name="Whatsapp"
                        vid="whatsapp"
                        rules="required"
                        v-slot="{errors}"
                        tag="div"
                        class="input-std"
                    >
                        <label>Whatsapp do Sindicato</label>
                        <input
                            type="text"
                            placeholder="Whatsapp do Sindicato"
                            v-model="form.whatsapp"
                            v-mask="'(##) #####-####'"
                        />
                        <p class="errors">{{errors[0]}}</p>
                    </validation-provider>

                    <validation-provider
                        name="Email"
                        vid="email"
                        rules="required"
                        v-slot="{errors}"
                        tag="div"
                        class="input-std"
                    >
                        <label>E-mail</label>
                        <input
                            type="text"
                            placeholder="Email do Sindicato"
                            v-model="form.email"
                        />
                        <p class="errors">{{errors[0]}}</p>
                    </validation-provider>
                </div>

                <div class="grid-1 form-3">
                    <validation-provider
                        name="Nome Presidente"
                        vid="nome"
                        rules="required"
                        v-slot="{errors}"
                        tag="div"
                        class="input-std"
                    >
                        <label>Nome do Presidente</label>
                        <input
                            type="text"
                            placeholder="Nome do Presidente"
                            v-model="form.nome_presidente"
                        />
                        <p class="errors">{{errors[0]}}</p>
                    </validation-provider>

                    <validation-provider
                        name="Data Mandato"
                        vid="data_mandato"
                        rules="required"
                        v-slot="{errors}"
                        tag="div"
                        class="input-std"
                    >
                        <label>Data do Mandato Atual</label>
                        <flat-pickr
                            v-model="form.data_mandato"
                            :config="config"
                            name="data-mandato"
                            id="data-mandato"
                            placeholder="DD/MM/AAAA"
                        >
                        </flat-pickr>
                        <p class="errors">{{errors[0]}}</p>
                    </validation-provider>

                    <validation-provider
                        name="Numero Trabalhadores"
                        vid="nro_trabalhadores"
                        rules="required"
                        v-slot="{errors}"
                        tag="div"
                        class="input-std"
                    >
                        <label>Nº Trabalhadores na Base</label>
                        <input
                            type="text"
                            placeholder="Nº Trabalhadores na Base"
                            v-model="form.nro_trabalhadores"
                        />
                        <p class="errors">{{errors[0]}}</p>
                    </validation-provider>

                    <validation-provider
                        name="Numero Sindicalizados"
                        vid="nro_sindicalizados"
                        rules="required"
                        v-slot="{errors}"
                        tag="div"
                        class="input-std"
                    >
                        <label>Nº de Sindicalizados</label>
                        <input
                            type="text"
                            placeholder="Nº de Sindicalizados"
                            v-model="form.nro_sindicalizados"
                        />
                        <p class="errors">{{errors[0]}}</p>
                    </validation-provider>
                </div>

                <h3 class="card-header">Endereço do Sindicato</h3>

                <div class="grid-1 mt-2 form-4">
                    <validation-provider
                        name="CEP"
                        vid="cep"
                        rules="required"
                        v-slot="{errors}"
                        tag="div"
                        class="input-std"
                    >
                        <label>CEP</label>
                        <input
                            type="text"
                            placeholder="CEP"
                            v-model="form.cep"
                            @blur="buscaCep"
                            v-mask="'#####-###'"
                            maxlength="9"
                        />
                        <p class="errors">{{errors[0]}}</p>
                    </validation-provider>

                    <validation-provider
                        name="Endereco"
                        vid="endereco"
                        rules="required"
                        v-slot="{errors}"
                        tag="div"
                        class="input-std"
                    >
                        <label>Endereco</label>
                        <input
                            type="text"
                            placeholder="Endereço"
                            v-model="form.endereco"
                        />
                        <p class="errors">{{errors[0]}}</p>
                    </validation-provider>

                    <validation-provider
                        name="Numero"
                        vid="nro"
                        rules="required"
                        v-slot="{errors}"
                        tag="div"
                        class="input-std"
                    >
                        <label>Número</label>
                        <input
                            type="text"
                            placeholder="Número"
                            v-model="form.nro"
                        />
                        <p class="errors">{{errors[0]}}</p>
                    </validation-provider>

                    <validation-provider
                        name="Bairro"
                        vid="bairro"
                        rules="required"
                        v-slot="{errors}"
                        tag="div"
                        class="input-std"
                    >
                        <label>Bairro</label>
                        <input
                            type="text"
                            placeholder="Bairro"
                            v-model="form.bairro"
                        />
                        <p class="errors">{{errors[0]}}</p>
                    </validation-provider>

                </div>

                <div class="grid-1 form-5">
                    <validation-provider
                        name="Cidade"
                        vid="cidade"
                        rules="required"
                        v-slot="{errors}"
                        tag="div"
                        class="input-std"
                    >
                        <label>Cidade</label>
                        <input
                            type="text"
                            placeholder="Cidade"
                            v-model="form.cidade"
                        />
                        <p class="errors">{{errors[0]}}</p>
                    </validation-provider>

                    <validation-provider
                        name="UF"
                        vid="uf"
                        rules="required"
                        v-slot="{errors}"
                        tag="div"
                        class="input-std"
                    >
                        <label>UF</label>
                        <input
                            type="text"
                            placeholder="Estado"
                            v-model="form.estado"
                        />
                        <p class="errors">{{errors[0]}}</p>
                    </validation-provider>
                </div>
                <div class="flex justify-end">
                    <button class="btn btn-primary">
                        {{ (!form.id) ? 'Salvar Sindicato' : 'Atualizar Sindicato' }}
                    </button>
                </div>
            </form>
        </validation-observer>
    </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import 'flatpickr/dist/themes/airbnb.css';
import { mask } from "vue-the-mask"

const Brasil = require('flatpickr/dist/l10n/pt.js').default.pt;
export default {
    name: 'form-sindicato',
    components: { flatPickr },
    directives: { mask },
    created() {
        this.popularSindicato(this.$route.params.id)
    },
    data() {
        return {
            form: {
                cnpj: '',
                nome_completo: '',
                nome_fantasia: '',
                telefone: '',
                celular: '',
                whatsapp: '',
                email: '',
                nome_presidente: '',
                data_mandato: '',
                nro_trabalhadores: '',
                nro_sindicalizados: '',
                cep: '',
                endereco: '',
                nro: '',
                bairro: '',
                cidade: '',
                estado: '',
                id: null
            },
            config: {
                wrap: true,
                altInput: true,
                altFormat: 'd/m/Y',
                dateFormat: 'Y-m-d',
                enableTime: false,
                allowInput: true,
                locale: Brasil,
            },
        }
    },
    methods: {
        async popularSindicato() {
            if (this.$route.params.id) {
                let sindicato = await this.getSindicato(this.$route.params.id)
                for(var key in sindicato) {
                    this.form[key] = sindicato[key]
                }
            }
        },

        async getSindicato(id) {
            let result = await this.axios('sindicatos/'+id)
            return result.data.sindicato
        },

        submitSindicato() {
            this.axios.post('sindicatos', this.form).then(response => {
                if (!this.form.id) {
                    this.submitUser(response.data.sindicato)
                } else {
                    this.$swal({
                        title: 'Sucesso',
                        text: 'O sindicato foi atualizado com sucesso',
                        icon: 'success',
                    })

                    this.$router.push('/sistema/sindicatos/lista-sindicatos')
                }
            }).catch(error => {
                this.$swal({
                    title: 'Algo de errado aconteceu.',
                    text: error.response.data.message,
                    icon: 'error',
                })
            })
        },

        submitUser(sindicato) {
            this.axios.post('register',{
                'name': sindicato.nome_completo,
                'email': sindicato.email,
                'cnpj': sindicato.cnpj,
                'imagem': null,
                'tipo': 2,
                'sindicato_id': sindicato.id,
                'ativo': 1,
                'inadiplente': 0,
                'password': 'regional'
            }).then(response => {
                if (response.status === 200) {
                    this.$swal({
                        title: 'Sucesso',
                        text: 'O sindicato foi criado com sucesso',
                        icon: 'success',
                    })
                    this.$router.push('/sistema/sindicatos/lista-sindicatos')
                }
            }).catch(error => {
                this.$swal({
                    title: 'Algo de errado aconteceu.',
                    text: error.response.data.message,
                    icon: 'error',
                })
            })
        },

        buscaCep() {
            let cep = this.form.cep.replace('-', '')
            if (cep.length === 8) {
                this.axios.get('https://viacep.com.br/ws/' + cep + '/json/', { baseURL: 'viacep.com.br' }).then(response => {
                    this.form.endereco = response.data.logradouro
                    this.form.bairro = response.data.bairro
                    this.form.cidade = response.data.localidade
                    this.form.numero = ''
                    this.form.estado = response.data.uf
                    this.$store.commit('loadingScreen/setLoading', false);
                }).catch(error => {
                    this.$store.commit('loadingScreen/setLoading', false);
                    this.form.endereco = ''
                    this.form.bairro = ''
                    this.form.cidade = ''
                    this.form.numero = ''
                    this.form.estado = ''
                    console.error(error)
                })
            } else {
                this.form.endereco = ''
                this.form.bairro = ''
                this.form.cidade = ''
                this.form.numero = ''
                this.form.estado = ''
            }
        },
    }
}
</script>
<style lang="scss" scoped>
.form-1{
    @media(min-width: 640px) {
        @apply grid-cols-3;
    }
    @media(min-width: 1024px) {
        @apply grid-cols-4;
    }
}
.form-2{
    @media(min-width: 640px) {
        @apply grid-cols-2;
    }
    @media(min-width: 1024px) {
        @apply grid-cols-4;
    }
}
.form-3{
    @media(min-width: 640px) {
        @apply grid-cols-2;
    }
    @media(min-width: 1024px) {
        @apply grid-cols-4;
    }
}
.form-4{
    @media(min-width: 640px) {
        @apply grid-cols-2;
    }
    @media(min-width: 1024px) {
        @apply grid-cols-4;
    }
}
.form-5 {
    @media(min-width: 640px) {
        @apply grid-cols-2;
    }
}
</style>
